<template>
  <div>
    <el-table
      :data="current_already_image_list"
      style="width: 100%">
      <el-table-column
        v-if="upload_column_show"
        label="縮圖"
        width="180"> 
        <template slot-scope="scope">
          <a target="_blank" :href="scope.row.image_url"><img :src="scope.row.image_url" alt="" width="50%"></a>
        </template>  
      </el-table-column>
      <el-table-column
        prop="title"
        label="標題"
        width="180">
      </el-table-column>
      <el-table-column
        v-if="upload_column_show"
        prop="description"
        label="敘述"
        width="300">
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            type="danger" icon="el-icon-close" circle size="medium"
            @click="inner_handle_list_delete(scope.$index, scope.row)"></el-button>
        </template>
      </el-table-column>
      <el-table-column label="編輯敘述" width="180" v-if="can_edit_description">
        <template slot-scope="scope">
          <el-button size="medium" @click="handle_edit_description_dialog(scope.$index, scope.row)">編輯敘述</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="編輯敘述"
      :visible.sync="edit_description_open"
      width="30%"
      :close-on-click-modal="false"
      >
      <span>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="請輸入敘述"
          v-model="description_area">
        </el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="edit_description_open = false">取 消</el-button>
        <el-button type="primary" @click="inner_handle_list_edit">確 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['already_image_list','upload_column_show', 'handle_list_delete', 'handle_list_edit', 'article_index', 'can_edit_description'],
  data() {
    return {
      current_already_image_list: {},
      edit_description_open: false,
      description_area: '',
      choose_edit_row: {},
      choose_edit_index: null
    }
  },
  created: async function () {
  },
  methods: {
    inner_handle_list_delete(index, row) {
      if(this.article_index!==null && typeof this.article_index!=='undefined') {
        this.handle_list_delete(index, row, this.article_index)
      }else {
        this.handle_list_delete(index, row)
      }
    },
    handleDelete($index, row){
      console.log($index)
      console.log(row)
      this.$confirm('是否確定刪除所選圖片', '刪除圖片', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.image_table.splice(row, 1)
          this.$message({
            type: 'success',
            message: '刪除成功!'
          });

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消刪除'
          });          
        });
    },
    handle_edit_description_dialog(index, row){
      // init
      this.edit_description_open = true

      this.$set(this, 'description_area', row.description)
      this.$set(this, 'choose_edit_row', row)
      this.$set(this, 'choose_edit_index', index)
    },
    inner_handle_list_edit(){
      // 改變值
      if(this.description_area !== this.choose_edit_row.description){
        let temp_row = JSON.parse(JSON.stringify(this.choose_edit_row))
        temp_row.description = this.description_area
        this.$set(this, 'choose_edit_row', temp_row)
      }

      this.$set(this.current_already_image_list[this.choose_edit_index], 'description', this.choose_edit_row.description)
      
      if(this.article_index!==null && typeof this.article_index!=='undefined') {
        this.handle_list_edit(this.choose_edit_index, this.choose_edit_row, this.article_index)
      }else {
        this.handle_list_edit(this.choose_edit_index, this.choose_edit_row)
      }

      this.edit_description_open = false
      this.$set(this, 'description_area', '')
      this.$set(this, 'choose_edit_row', {})
      this.$set(this, 'choose_edit_index', null)
    },
  },
  watch: {
    'already_image_list': {
      handler (d) {
        this.current_already_image_list = JSON.parse(JSON.stringify(d))
      },
      immediate: true
    }
  }
}
</script>

<style>

</style>
